import { Sun } from 'lucide-react';
import type { ComponentPropsWithoutRef } from 'react';
import { cn } from '../lib/utils';

export type SunIconProps = ComponentPropsWithoutRef<typeof Sun>;

export function SunIcon({ className, ...props }: SunIconProps) {
  return <Sun className={cn('size-icon-sm', className)} {...props} />;
}
